import { useSelector } from 'react-redux';
import { staticComponentValueConverter } from '../StaticComponentValues';
import { createImageUrl } from '../../../../../../../helper/Converters';
import { useMemo } from 'react';
import { HexToHueConverter } from '../../../../../../../helper/ColorToHueConverter';
function Image_1({ item }) {
  const customization = staticComponentValueConverter(item?.customization);
  const staticValues = useSelector(state => state.themeSlice?.staticValues);
  const shareIconFilter = useMemo(
    () => HexToHueConverter(customization?.shareIconColor),
    [customization?.shareIconColor],
  );
  const heartIconFilter = useMemo(
    () => HexToHueConverter(customization?.heartIconColor),
    [customization?.heartIconColor],
  );
  const selectedProduct = useSelector(state => state.themeSlice.selectedProduct);
  const firstProduct = selectedProduct?.data;
  const image = createImageUrl(firstProduct?.variants?.[0]?.images?.[0]?.id);
  const rating = 4;
  const totalStars = 5;

  return (
    <div>
      <img
        width={'100%'}
        style={{ height: customization?.productImageHeight, objectFit: customization?.backgroundSize }}
        src={image || process.env.REACT_APP_DEFAULT_IMAGE}
        alt=""
      />
      <div className="border-b-1 border-stone-300 mx-3" style={{ paddingInlineEnd: 10 }}>
        {customization?.showBrandName === 'show' && (
          <div
            className="flex flex-row justify-between align-center "
            style={{
              fontSize: customization?.brandNameTextSize,
              color: customization?.brandNameTextColor,
              fontStyle: customization?.brandNameTextStyle,
              fontWeight: customization?.brandNameTextWeight,
              paddingTop: staticValues[10],
            }}
          >
            {firstProduct?.brand?.name || 'Ürün Markası'}
          </div>
        )}
        <div
          className={`${customization?.showBrandName === 'show'
              ? 'flex flex-row justify-between align-center'
              : 'flex flex-row justify-between align-center + pt-2.5'
            }`}
        >
          <div
            style={{
              textAlign: 'left',
              fontSize: customization?.imageTextSize,
              color: customization?.imageTextColor,
              fontStyle: customization?.imageTextStyle,
              fontWeight: customization?.imageTextWeight,
            }}
          >
            <div dangerouslySetInnerHTML={{ __html: firstProduct?.name || 'Ürün Başlığı' }}></div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', flexShrink: 0, gap: 5 }}>
            {customization?.isHeartIcon && (
              <div
                className=" 2xl:rounded-[10px] rounded-[7.97341324459px] p-[5px] 2xl:p-[6.2708401617px] right-0"
                style={{
                  backgroundColor: customization?.heartIconBackgroundColor,
                  borderRadius: customization?.heartIconBorderRadius,
                }}
              >
                <img
                  className="shrink-0"
                  src={customization?.heartIcon}
                  alt=""
                  style={{ filter: heartIconFilter, width: customization?.heartIconWidth }}
                />
              </div>
            )}
            {customization?.isShareIcon && (
              <div
                className=" 2xl:rounded-[10px] rounded-[7.97341324459px] p-[5px] 2xl:p-[6.2708401617px] right-0"
                style={{
                  backgroundColor: customization?.shareIconBackgroundColor,
                  borderRadius: customization?.shareIconBorderRadius,
                }}
              >
                <img
                  className="shrink-0"
                  src={customization?.shareIcon}
                  alt=""
                  style={{ filter: shareIconFilter, width: customization?.shareIconWidth }}
                />
              </div>
            )}
          </div>
        </div>
        {customization?.isShowStar === 'show' && (
          <div style={{ display: 'flex', gap: '5px' }}>
            {[...Array(totalStars)].map((item, index) => {
              const starIndex = index + 1;

              return (
                <span
                  key={starIndex}
                  style={{
                    cursor: 'pointer',
                    color: starIndex <= rating ? '#FFD700' : '#ccc',
                    fontSize: customization?.starSize,
                  }}
                >
                  &#9733;
                </span>
              );
            })}
          </div>
        )}

        <div
          className="flex flex-row justify-between align-center "
          style={{
            display: customization?.showBarcode,
            fontSize: customization?.barcodeTextSize,
            color: customization?.barcodeTextColor,
            fontStyle: customization?.barcodeTextStyle,
            fontWeight: customization?.barcodeTextWeight,
          }}
        >
          Ürün Barkodu: {firstProduct?.variants?.[0]?.barcodeList?.[0] || '9003579308936'}
        </div>
        {customization?.isShowTag === 'show' && (
          <div className="flex flex-row gap-2">
            {firstProduct?.tags?.map((item, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                  backgroundColor: customization?.tagBackgroundColor,
                  width: 'fit-content',
                  borderRadius: customization?.tagBorderRadius,
                  padding: customization?.tagBoxPadding,
                  marginTop: '10px',

                  marginBottom: '10px',
                }}
              >
                <div>
                  <svg
                    fill={customization?.tagIconColor}
                    width={customization?.tagIconSize}
                    height={customization?.tagIconSize}
                    viewBox="0 0 30.72 30.72"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="m30.719 12.488 0 -10.151c0 -1.288 -1.048 -2.337 -2.336 -2.337H18.022c-0.65 0 -1.635 0 -2.278 0.643L0.566 15.822c-0.365 0.365 -0.566 0.849 -0.566 1.365 0 0.516 0.201 1.001 0.565 1.366l11.604 11.602C12.533 30.519 13.017 30.72 13.533 30.72s1.001 -0.201 1.365 -0.565l15.179 -15.179c0.651 -0.649 0.647 -1.584 0.643 -2.487zm-2.001 1.13L13.526 28.796 1.924 17.18 17.086 2.015c0.153 -0.095 0.702 -0.095 0.93 -0.095l0.432 0.001 9.936 -0.001c0.23 0 0.416 0.187 0.416 0.417V12.496c0.002 0.365 0.004 0.976 -0.081 1.122M23.04 3.84c-2.121 0 -3.84 1.719 -3.84 3.84s1.719 3.84 3.84 3.84 3.84 -1.719 3.84 -3.84 -1.719 -3.84 -3.84 -3.84m0 5.76c-1.06 0 -1.92 -0.86 -1.92 -1.92s0.86 -1.92 1.92 -1.92 1.92 0.86 1.92 1.92 -0.86 1.92 -1.92 1.92" />
                  </svg>
                </div>
                <div
                  style={{
                    fontSize: customization?.tagTextSize,
                    color: customization?.tagTextColor,
                    fontStyle: customization?.tagTextStyle,
                    fontWeight: customization?.tagTextWeight,
                  }}
                >
                  {item?.name}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Image_1;
